
"use strict";

class QuestionDependency {


  constructor(private onQuestion, private question, private answer) {}

  questionIsAnsweredBy(person) {
      return this.question.isAnsweredBy(person);
  }

  isMetBy(person) {
      // TODO - This only works for multiple choice questions. All dependencies
      // are multiple choice so it is fine for now but if we ever add other
      // types of questions as dependencies this will need upgrading
      return (
        this.question.answerForPerson(person).value &&
        this.question.answerForPerson(person).value.id === this.answer
      );
  }

  remove() {
      return this.onQuestion.removeDependency(this.question.id, this.answer);
  }

}

export default QuestionDependency;
